/**
 * Diet Grid — filtrowanie kart diet po kategorii.
 * Markup: partials/blocks/blocks-diet-grid.php
 */

const ACTIVE = ["bg-obsidian", "text-sunburst"];
const IDLE = ["bg-transparent", "text-obsidian", "hover:bg-obsidian/10"];

function setButtonState(button, isActive) {
    button.setAttribute("aria-pressed", isActive ? "true" : "false");
    button.classList.remove(...(isActive ? IDLE : ACTIVE));
    button.classList.add(...(isActive ? ACTIVE : IDLE));
}

function init() {
    const filterBars = document.querySelectorAll("[data-diet-filters]");
    if (!filterBars.length) return;

    filterBars.forEach((bar) => {
        const section = bar.closest(".diet-grid");
        if (!section) return;

        const list = section.querySelector("[data-diet-list]");
        if (!list) return;

        const buttons = bar.querySelectorAll("[data-diet-filter]");
        const cards = list.querySelectorAll("[data-diet-category]");

        buttons.forEach((button) => {
            button.addEventListener("click", () => {
                const selected = button.dataset.dietFilter;

                buttons.forEach((other) => setButtonState(other, other === button));

                cards.forEach((card) => {
                    const matches = selected === "all" || card.dataset.dietCategory === selected;
                    card.classList.toggle("hidden", !matches);
                });
            });
        });
    });
}

export default {init};
